module.exports = __webpack_public_path__ + "img/20161003_190543.d0ee248a.jpg";